import { render, staticRenderFns } from "./AddHonorList.vue?vue&type=template&id=08ee2f97"
import script from "./AddHonorList.vue?vue&type=script&lang=js"
export * from "./AddHonorList.vue?vue&type=script&lang=js"
import style0 from "./AddHonorList.vue?vue&type=style&index=0&id=08ee2f97&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports